<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'FormContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataTemplates: []
            }
        },
        methods: {
        }
    }
</script>
